import { render, staticRenderFns } from "./MoveHorizontalDivider.vue?vue&type=template&id=0c45e470&scoped=true&"
import script from "./MoveHorizontalDivider.vue?vue&type=script&lang=js&"
export * from "./MoveHorizontalDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45e470",
  null
  
)

export default component.exports